import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      padding: theme.spacing(0)
    } 
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  },
  errormessage: {
    margin: "2rem auto",
    padding: theme.spacing(2),
    maxWidth: "600px",
    border: `1px solid ${theme.palette.error?.main}`,
    borderRadius: "8px",
    color: theme.palette.error?.main,
    fontSize: "1.2rem",
    fontWeight: "bold",
    textAlign: "center",
  }
}));
